import { get, map } from 'lodash';

const isUUID = (value: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value,
  );

const getOptions = <T>(data: T[], labelKey?: keyof T, valueKey?: keyof T) =>
  map(data, (item) => ({
    label: get(item, labelKey || 'name'),
    value: get(item, valueKey || 'id'),
  }));

export const formUtils = {
  isUUID,
  getOptions,
};
